import { createAsyncThunk } from "@reduxjs/toolkit";
import setBaseURL from "../libs/utilities/helpers/BaseURLHelper";
import { api } from "./config/axiosConfig";


//getAPi config means path , environment variables , endpoints such as
const getAPIConfig = (serviceId) => {
  // if (!serviceId) return null;
  const envVarName = `REACT_APP_BASE_URL_AUTOCODER`;
  // const apiPath = serviceId;    
  return {
    baseURL: process.env[envVarName],
    conversation: `/autocoder/conversation`,
    feedback: "/autocoder/feedback",
    download: "/autocoder/download"
  };
};

export class AutoCoderChatBotTemplateAPI {

  // generateAnswer = createAsyncThunk(
  //     "",
  //     async (requestBody, { rejectWithValue }) => {
  //         try {
  //             const { baseURL, conversation } = getAPIConfig();
  //             setBaseURL(api, baseURL);
  //             const response = await api.post(conversation, requestBody);
  //             return response.data;
  //         } catch (error) {
  //             return rejectWithValue(error.response.data);
  //         }
  //     }
  // );

  generateAnswer = createAsyncThunk(
    "chat/generateAnswer",
    async (requestBody, { rejectWithValue, signal }) => {
      try {
        const { baseURL, conversation } = getAPIConfig();
        setBaseURL(api, baseURL);

        const response = await api.post(conversation, requestBody, {
          signal,
        });

        return response.data;
      } catch (error) {
        if (error.name === "CanceledError" || error.name === "AbortError") {
          throw error;
        }
        return rejectWithValue(error.response?.data || "Something went wrong");
      }
    }
  );

  saveFeedback = createAsyncThunk(
    "",
    async ({ serviceId, ...data }, { rejectWithValue }) => {
      try {
        const { baseURL, feedback } = getAPIConfig();

        setBaseURL(api, baseURL);
        let response = await api.post(feedback, data);
        return response.data;
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );


  downloadFile = createAsyncThunk(
    "",
    async ({ serviceId, ...data }, { rejectWithValue }) => {
      try {
        const { baseURL, download } = getAPIConfig();

        setBaseURL(api, baseURL);
        let response = await api.post(download, data);
        return response.data;
      } catch (error) {
        return error.message;
      }
    }
  )


}
